<template>
  <div class="view-inner">

    <!-- Header -->
    <div class="page-header mb-4">
      <div>
        <h1 class="page-header-title"><i class="bi bi-calculator me-2"></i>Calculadora de Envíos</h1>
        <p class="page-header-sub"><i class="bi bi-info-circle me-1"></i>Los precios <strong>no incluyen IGV</strong>. El IGV se añadirá al emitir la factura.</p>
      </div>
    </div>

    <div class="cotizador-body">

      <!-- Paso 1: Tipo de envío -->
      <div class="cotizador-step">
        <div class="step-num">1</div>
        <div class="step-content">
          <div class="step-title">¿A dónde es el envío?</div>
          <div class="tipo-cards">
            <div
              class="tipo-card"
              :class="{ selected: tipoEnvio === 'local' }"
              @click="seleccionarTipo('local')"
            >
              <i class="bi bi-building"></i>
              <span>Local</span>
              <small>Lima y alrededores</small>
            </div>
            <div
              class="tipo-card"
              :class="{ selected: tipoEnvio === 'provincia' }"
              @click="seleccionarTipo('provincia')"
            >
              <i class="bi bi-geo-alt"></i>
              <span>Provincia</span>
              <small>Destinos fuera de Lima</small>
            </div>
          </div>
        </div>
      </div>

      <!-- Paso 2: Subtipo -->
      <transition name="fade">
        <div v-if="tipoEnvio" class="cotizador-step">
          <div class="step-num">2</div>
          <div class="step-content">
            <div class="step-title">¿Qué tipo de servicio?</div>

            <!-- Subtipos provincia -->
            <div v-if="tipoEnvio === 'provincia'" class="subtipo-cards">
              <div
                v-for="op in opcionesProvincia"
                :key="op.value"
                class="subtipo-card"
                :class="{ selected: subtipoProvincia === op.value }"
                @click="subtipoProvincia = op.value"
              >
                <i :class="op.icono"></i>
                <span>{{ op.label }}</span>
              </div>
            </div>

            <!-- Subtipos local -->
            <div v-if="tipoEnvio === 'local'" class="subtipo-cards">
              <div
                v-for="op in opcionesLocal"
                :key="op.value"
                class="subtipo-card"
                :class="{ selected: subtipoLocal === op.value }"
                @click="subtipoLocal = op.value"
              >
                <i :class="op.icono"></i>
                <span>{{ op.label }}</span>
              </div>
            </div>
          </div>
        </div>
      </transition>

      <!-- Paso 3: Componente de cálculo -->
      <transition name="fade">
        <div v-if="subtipoProvincia || subtipoLocal" class="cotizador-step">
          <div class="step-num">3</div>
          <div class="step-content">
            <div class="step-title">Datos del envío</div>
            <div class="cotizador-form-card">
              <ConsolidadoTerrestre v-if="subtipoProvincia === 'consolidadoTerrestre'" />
              <ConsolidadoAereo     v-if="subtipoProvincia === 'consolidadoAereo'" />
              <ExclusivoTerrestre   v-if="subtipoProvincia === 'exclusivoTerrestre'" />
              <DocumentoTerrestre   v-if="subtipoProvincia === 'documentoTerrestre'" />
              <DocumentoAereo       v-if="subtipoProvincia === 'documentoAereo'" />
              <Local                v-if="subtipoLocal === 'mercaderiaLocal'" />
              <EmergenciaLocal      v-if="subtipoLocal === 'documentoLocal'" />
            </div>
          </div>
        </div>
      </transition>

    </div>
  </div>
</template>

<script>
import ConsolidadoTerrestre from '@/components/envios/ConsolidadoTerrestre.vue'
import ConsolidadoAereo from '@/components/envios/ConsolidadoAereo.vue'
import ExclusivoTerrestre from '@/components/envios/ExclusivoTerrestre.vue'
import DocumentoTerrestre from '@/components/envios/DocumentoTerrestre.vue'
import DocumentoAereo from '@/components/envios/DocumentoAereo.vue'
import Local from '@/components/envios/Local.vue'
import EmergenciaLocal from '@/components/envios/EmergenciaLocal.vue'

export default {
  name: 'CotizadorPage',
  components: { ConsolidadoTerrestre, ConsolidadoAereo, ExclusivoTerrestre, DocumentoTerrestre, DocumentoAereo, Local, EmergenciaLocal },
  data() {
    return {
      tipoEnvio: '',
      subtipoProvincia: '',
      subtipoLocal: '',
      opcionesProvincia: [
        { value: 'consolidadoTerrestre', label: 'Mercadería Consolidado Terrestre',  icono: 'bi bi-truck' },
        { value: 'consolidadoAereo',     label: 'Mercadería Consolidado Aéreo',      icono: 'bi bi-airplane' },
        { value: 'exclusivoTerrestre',   label: 'Mercadería Exclusivo Terrestre',    icono: 'bi bi-truck-front' },
        { value: 'documentoTerrestre',   label: 'Documentos Terrestre',   icono: 'bi bi-file-earmark-text' },
        { value: 'documentoAereo',       label: 'Documentos Aéreo',       icono: 'bi bi-file-earmark-arrow-up' },
      ],
      opcionesLocal: [
        { value: 'documentoLocal',  label: 'Normal',      icono: 'bi bi-file-text' },
        { value: 'mercaderiaLocal', label: 'Urgencia / Emergencia', icono: 'bi bi-box-seam' },        
      ],
    }
  },
  methods: {
    seleccionarTipo(tipo) {
      this.tipoEnvio = tipo;
      this.subtipoProvincia = '';
      this.subtipoLocal = '';
    }
  }
}
</script>

<style scoped>

/* Body */
.cotizador-body {
  max-width: 100%;
  padding: 0;
}

/* Steps */
.cotizador-step {
  display: flex;
  gap: 16px;
  margin-bottom: 28px;
}
.step-num {
  width: 32px;
  height: 32px;
  min-width: 32px;
  border-radius: 50%;
  background: #3f51b5;
  color: #fff;
  font-weight: 700;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 2px;
}
.step-content { flex: 1; }
.step-title {
  font-weight: 700;
  color: #37474f;
  margin-bottom: 14px;
  font-size: 0.95rem;
}

/* Tipo cards */
.tipo-cards {
  display: flex;
  gap: 14px;
  flex-wrap: wrap;
}
.tipo-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 140px;
  padding: 20px 12px;
  border: 2px solid #e0e0e0;
  border-radius: 12px;
  background: #fff;
  cursor: pointer;
  transition: all 0.2s;
  text-align: center;
  gap: 6px;
}
.tipo-card i { font-size: 1.8rem; color: #9e9e9e; }
.tipo-card span { font-weight: 600; font-size: 0.9rem; color: #424242; }
.tipo-card small { font-size: 0.72rem; color: #9e9e9e; }
.tipo-card:hover { border-color: #3f51b5; background: #f5f6ff; }
.tipo-card:hover i { color: #3f51b5; }
.tipo-card.selected { border-color: #3f51b5; background: #e8eaf6; }
.tipo-card.selected i { color: #3f51b5; }
.tipo-card.selected span { color: #3f51b5; }

/* Subtipo cards */
.subtipo-cards {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}
.subtipo-card {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  background: #fff;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 0.85rem;
  font-weight: 500;
  color: #616161;
}
.subtipo-card i { font-size: 1rem; color: #9e9e9e; }
.subtipo-card:hover { border-color: #3f51b5; color: #3f51b5; background: #f5f6ff; }
.subtipo-card:hover i { color: #3f51b5; }
.subtipo-card.selected { border-color: #3f51b5; background: #e8eaf6; color: #3f51b5; font-weight: 600; }
.subtipo-card.selected i { color: #3f51b5; }

/* Form card */
.cotizador-form-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(63,81,181,0.08);
  padding: 24px;
}

/* Transition */
.fade-enter-active, .fade-leave-active { transition: opacity 0.25s, transform 0.25s; }
.fade-enter-from, .fade-leave-to { opacity: 0; transform: translateY(-6px); }

@media (max-width: 576px) {
  .tipo-card { width: calc(50% - 7px); }
  .cotizador-step { gap: 10px; }
}
</style>
